"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMaxVoterWeightRecordAddress = exports.MaxVoterWeightRecord = exports.getVoterWeightRecordAddress = exports.VoterWeightRecord = exports.VoterWeightAction = void 0;
var web3_js_1 = require("@solana/web3.js");
var VoterWeightAction;
(function (VoterWeightAction) {
    VoterWeightAction[VoterWeightAction["CastVote"] = 0] = "CastVote";
    VoterWeightAction[VoterWeightAction["CommentProposal"] = 1] = "CommentProposal";
    VoterWeightAction[VoterWeightAction["CreateGovernance"] = 2] = "CreateGovernance";
    VoterWeightAction[VoterWeightAction["CreateProposal"] = 3] = "CreateProposal";
    VoterWeightAction[VoterWeightAction["SignOffProposal"] = 4] = "SignOffProposal";
})(VoterWeightAction = exports.VoterWeightAction || (exports.VoterWeightAction = {}));
var VoterWeightRecord = /** @class */ (function () {
    function VoterWeightRecord(args) {
        this.accountDiscriminator = new Uint8Array([50, 101, 102, 57, 57, 98, 52, 98]);
        this.realm = args.realm;
        this.governingTokenMint = args.governingTokenMint;
        this.governingTokenOwner = args.governingTokenOwner;
        this.voterWeight = args.voterWeight;
        this.voterWeightExpiry = args.voterWeightExpiry;
        this.weightAction = args.weightAction;
        this.weightActionTarget = args.weightActionTarget;
    }
    return VoterWeightRecord;
}());
exports.VoterWeightRecord = VoterWeightRecord;
/**
 * Returns the default address for VoterWeightRecord
 * Note: individual addins are not required to use the default address and it can vary between different implementations
 **/
function getVoterWeightRecordAddress(programId, realm, governingTokenMint, governingTokenOwner) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, voterWeightRecordAddress;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, web3_js_1.PublicKey.findProgramAddress([
                        Buffer.from('voter-weight-record'),
                        realm.toBuffer(),
                        governingTokenMint.toBuffer(),
                        governingTokenOwner.toBuffer(),
                    ], programId)];
                case 1:
                    _a = __read.apply(void 0, [_b.sent(), 1]), voterWeightRecordAddress = _a[0];
                    return [2 /*return*/, voterWeightRecordAddress];
            }
        });
    });
}
exports.getVoterWeightRecordAddress = getVoterWeightRecordAddress;
var MaxVoterWeightRecord = /** @class */ (function () {
    function MaxVoterWeightRecord(args) {
        this.accountDiscriminator = new Uint8Array([57, 100, 53, 102, 102, 50, 57, 55]);
        this.realm = args.realm;
        this.governingTokenMint = args.governingTokenMint;
        this.maxVoterWeight = args.maxVoterWeight;
        this.maxVoterWeightExpiry = args.maxVoterWeightExpiry;
    }
    return MaxVoterWeightRecord;
}());
exports.MaxVoterWeightRecord = MaxVoterWeightRecord;
/**
 * Returns the default address for MaxVoterWeightRecord
 * Note: individual addins are not required to use the default address and it can vary between different implementations
 **/
function getMaxVoterWeightRecordAddress(programId, realm, governingTokenMint) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, maxVoterWeightRecordAddress;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, web3_js_1.PublicKey.findProgramAddress([
                        Buffer.from('max-voter-weight-record'),
                        realm.toBuffer(),
                        governingTokenMint.toBuffer(),
                    ], programId)];
                case 1:
                    _a = __read.apply(void 0, [_b.sent(), 1]), maxVoterWeightRecordAddress = _a[0];
                    return [2 /*return*/, maxVoterWeightRecordAddress];
            }
        });
    });
}
exports.getMaxVoterWeightRecordAddress = getMaxVoterWeightRecordAddress;
//# sourceMappingURL=accounts.js.map